import React, { useState, useEffect } from "react";
import image from "../../../../Resources/images/ims.png";
import BookingDatas from "../BookingDatas/BookingDatas";
import { IoIosArrowForward } from "react-icons/io";
import { GiSevenPointedStar } from "react-icons/gi";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useLocation } from "react-router-dom";
import {
  FacebookShareButton,
  FacebookIcon,
  PinterestShareButton,
  PinterestIcon,
  RedditShareButton,
  RedditIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "next-share";
function RightDashboardSection({ bookingData }) {
  const [filtered, setFiltered] = useState("");
  const [shareLink, setShareLink] = useState(false);
  const [copied, setCopied] = useState(false);
  const [copyUrl, setCopyUrl] = useState("");
  const location = useLocation();
  console.log(location.pathname);
  useEffect(() => {
    // if (router.isReady) {
    // const { id } = location.pathname;
    setCopyUrl(location.pathname);

    setShareLink(`http://localhost:3001${copyUrl}`);
    // }
    const interval = setTimeout(() => {
      if (copied) {
        setCopied(false);
      }
    }, 2000);
    return () => {
      clearTimeout(interval);
    };
  }, [copyUrl, copied]);
  // }, [router.isReady, copyUrl, router, copied, router.query]);
  return (
    <div className=" w-full   h-full  laptopM:px-7 ">
      <div className="flex gap-2 bg-gray-300 tablet:justify-between laptopM:justify-start  p-4 rounded-md">
        <div className="">
          <div className=" font-bold">
            Get the best with{" "}
            <div className="text-blue-800 text-3xl">Our system</div>
          </div>
          {/* <div className="text-gray-600 text-sm font-semibold my-1">
            business section
          </div> */}
          <div className="text-gray-500 text-xs mb-1">
            Attract more clients and get online booking by sharingyour online
            link
          </div>
          <div className=" my-2">
            {/* <button
              className="capitalize  font-semibold text-sm rounded-md px-4 
            py-2 bg-yellow-500 text-white hover:bg-opacity-80 "
            >
              register here!
            </button> */}
          </div>
        </div>
        <div className="w-40 mt-10">
          <img src={image} alt="Loading .." height={100} width={500} />
        </div>
      </div>
      <div className="flex flex-col tablet:flex-row laptopM:flex-col gap-0  tablet:gap-5  laptopM:gap-0 ">
        <div className="bg-yellow-500 text-white p-6 my-5 rounded-sm">
          <div className="font-bold">Share Link to Your Online System</div>
          <div className="text-xs w-11/12 my-1 font-normal">
            Attracts more clients and get online bookings by sharing your online
            links
          </div>
          <div className="capitalize flex gap-4  mt-4 text-sm font-semibold">
            <div className="px-3  flex items-center gap-3 capitalize py-0.5   rounded-md boder">
              share:
              <FacebookShareButton
                // {/* Url you want to share */}
                // url={`www.e-aribt.com/viewDetails/${copyUrl}`}
                url={`www.facebook.com`}
              >
                <FacebookIcon
                  size={30}
                  round
                  className="hover:scale-125 transition-all ease-in-out duration-300 hover:opacity-80  rounded w-8 h-8"
                />
              </FacebookShareButton>
              <WhatsappShareButton
                // {/* Url you want to share */}
                // url={`www.e-aribt.com/viewDetails/${copyUrl}`}
                url={`www.whatsapp.com`}
              >
                <WhatsappIcon
                  size={30}
                  round
                  className="hover:scale-125 transition-all ease-in-out duration-300 hover:opacity-80  rounded w-8 h-8"
                />
              </WhatsappShareButton>
            </div>
            <CopyToClipboard text={shareLink} onCopy={() => setCopied(true)}>
              <button className="px-3 capitalize py-0.5 hover:bg-gray-800  rounded-md border">
                copy link
              </button>
            </CopyToClipboard>
          </div>
        </div>

        <div className="bg-gray-800  text-white p-6 my-1 tablet:my-5 laptopM:my-1 rounded-md ">
          <div className="flex gap-2 ">
            <div>
              <GiSevenPointedStar className="bg-white  text-gray-800 rounded-full p-1.5 w-8 h-8" />
            </div>
            <div>
              <div className="font-semibold flex gap-5 items-center ">
                <div> You have 5 new appoitments </div>{" "}
                <div>
                  {" "}
                  <IoIosArrowForward />
                </div>
              </div>
              <div className="capitalize tablet:mt-5 mt-0 laptopM:mt-0 text-[11px] cursor-pointer w-fit underline font-semibold ">
                visit now
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="relative ">
        <div
          className={`${
            copied ? " scale-100 " : "scale-0"
          } transition-all duration-700 delay-100 ease-in-out bg-[#232323]
               w-full bg-opacity-50 text-black flex justify-center items-center `}
        >
          <div className="px-2 py-1 capitalize text-white">
            copied link sucessfully
          </div>
        </div>
      </div>
      <div className="font-bold text-gray-700 capitalize my-4 ">
        today's bookings
      </div>
      <BookingDatas
        Status="accepted"
        bookingData={bookingData}
        filtered={filtered}
        active={"all"}
      />
    </div>
  );
}

export default RightDashboardSection;
